import React from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';

interface NoApplicationsMessageProps {
    label: string;
}

const NoApplicationsMessage: React.FC<NoApplicationsMessageProps> = ({ label }) => {
    const theme = useTheme();

    return (
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <Typography
                align="center"
                variant="body1"
                style={{ color: theme.palette.secondary.main }}
            >
                {label === 'IN PROGRESS'
                    ? `There are currently no applications in progress`
                    : `There are currently no completed applications`}
            </Typography>
        </Box>
    );
};

export default NoApplicationsMessage;
